export type Language = 'fi' | 'en';

export const translations: Record<Language, Record<string, string>> = {
    'fi': {
        'export': 'Vie Exceliin',
        'sections': 'Osiot',
        'sections_and_content': 'Osiot ja sisällöt',
        'start': 'Aloita',
        'answer': 'Vastaa',
        'translate_from': 'Käännä kielestä',
        'play_again': 'Pelaa uudelleen',
        'remove_selection': 'Poista valinta',
        'continue': 'Jatka',
        'choose_answer': 'Valitse vastaus',
        'close': 'Sulje',
        'fill_all_fields': 'Täytä kaikki kentät',
        'select_multiple_info': 'Valitse yksi tai useampi vaihtoehto',
        'select_single_info': 'Valitse yksi vaihtoehto',
        'order_info': 'Järjestä vaihtoehdot haluamaasi järjestykseen',
        'connect_info': 'Yhdistä vaihtoehdot vetämällä ne toistensa päälle',
        'error_loading_game': 'Virhe ladattaessa peliä',
        'points_scored': 'Pisteet',
        'game_average': 'Pelin keskiarvo',
        'all_players_average': 'Kaikkien pelaajien keskiarvo',
        'pages': 'Sivut',
        'filter': 'Suodata',
        'search_games': 'Hae pelejä',
        'status': 'Tila',
        'status_published': 'Julkaistu',
        'status_draft': 'Luonnos',
        'status_archived': 'Arkistoitu',
        'status_not_in_use': 'Ei käytössä',
        'name': 'Nimi',
        'games_played': 'Pelattuja pelejä',
        'modified': 'Muokattu',
        'all': 'Kaikki',
        'clear_filters': 'Tyhjennä suodattimet',
        'edit': 'Muokkaa',
        'common_info': 'Yleistiedot',
        'average_duration': 'Keskimääräinen kesto',
        'average': 'Keskiarvo',
        'min': 'min',
        'sec': 'sek',
        'average_points': 'Keskimääräiset pisteet',
        'max_points': 'Maksimipisteet',
        'game_image': 'Pelin kuva',
        'general': 'Yleistiedot',
        'slug': 'Osoite',
        'description': 'Kuvaus',
        'excerpt': 'Nostoteksti',
        'outro_text': 'Vastaamisen jälkeinen viesti',
        'outro_text_info': 'Tämä teksti näytetään käyttäjälle, kun hän on vastannut kysymykseen.',
        'multiple': 'Useita vastauksia',
        'content_type': 'Sisältötyyppi',
        'content': 'Sisältö',
        'title': 'Otsikko',
        'select_options': 'Vaihtoehdot',
        'add_option': 'Lisää vaihtoehto',
        'points': 'Pisteet',
        'order_options': 'Järjestä vaihtoehdot',
        'connect_options': 'Yhdistä vaihtoehdot',
        'save': 'Tallenna',
        'select_content_type': 'Valitse sisällön tyyppi',
        'all_types': 'Kaikki tyypit',
        'type_slide': 'Slide',
        'type_select': 'Valinta',
        'type_order': 'Järjestä',
        'type_connect': 'Yhdistä',
        'type_select_multiple': 'Monivalinta',
        'type_text': 'Tekstivastaus',
        'type_image': 'Kuva',
        'type_title': 'Väliotsikko',
        'new_question': 'Uusi kysymys',
        'new_content': 'Uusi sisältö',
        'theme': 'Teema',
        'search': 'Hae ...',
        'select': 'Valitse',
        'new_section': 'Uusi osio',
        'new_game': 'Uusi peli',
        'quit_game': 'Poistu',
        'submit': 'Lähetä',
        'cancel': 'Peruuta',
        'add_new': 'Lisää uusi',
        'section_updated': 'Osio päivitetty',
        'section_created': 'Osio luotu',
        'not_available': 'Ei saatavilla',
        'game_section_order_updated': 'Pelin osioiden järjestys päivitetty',
        'game_saved': 'Pelin tiedot tallennettu',
        'question_created': 'Kysymys luotu',
        'question_updated': 'Kysymys päivitetty',
        'add_language': 'Lisää kieli',
        'select_language': 'Valitse kieli',
        'edit_order': 'Muokkaa järjestystä',
        'language_versions': 'Kieliversiot',
        'version': 'Versio',
        'session': 'Pelisessio',
        'sessions': 'Pelisessiot',
        'latest_sessions': 'Viimeisimmät istunnot',
        'started': 'Aloitettu',
        'ended': 'Päättyi',
        'question_language': 'Kysymyksen kieli',
        'search_questions': 'Hae kysymyksiä',
        'show_all': 'Näytä kaikki',
        'played': 'Pelattu',
        'created': 'Luotu',
        'language': 'Kieli',
        'languages': 'Kielet',
        'type': 'Tyyppi',
        'duration': 'Kesto',
        'select_status': 'Valitse tila',
        'search_sessions': 'Hae sessioita',
        'games': 'Pelit',
        'game': 'Peli',
        'questions': 'Kysymykset',
        'questions_played': 'Pelattuja kysymyksiä',
        'users': 'Käyttäjät',
        'player_name': 'Pelaajan nimi',
        'duplicate': 'Kopioi peli',
        'game_duplicated': 'Peli kopioitu',
        'new_theme': 'Uusi teema',
        'add_theme': 'Lisää teema',
        'image': 'Kuva',
        'add_user': 'Lisää käyttäjä',
        'search_users': 'Hae käyttäjiä',
        'add_team': 'Lisää tiimi',
        'teams': 'Tiimit',
        'email': 'Sähköposti',
        'is_staff': 'Ylläpitäjä',
        'is_active': 'Käytössä',
        'new_user': 'Uusi käyttäjä',
        'edit_user': 'Käyttäjän muokkaus',
        'first_name': 'Etunimi',
        'last_name': 'Sukunimi',
        'password': 'Salasana',
        'repeat_password': 'Toista salasana',
        'new_team': 'Uusi tiimi',
        'team_name': 'Tiimin nimi',
        'allowed_emails': 'Sallitut sähköpostipäätteet',
        'section_contents': 'Osion sisällöt',
        'display_correct_answers': 'Näytä oikeat vastaukset',
        'select_theme': 'Valitse teema',
        'question_and_answer': 'Kysymys ja vastaus',
        'answered': 'Vastattiin',
        'of_answers': 'vastauksista',
        'slides': 'Slidet',
        'order': 'Järjestys',
        'average_order': 'Keskimääräinen järjestys',
        'game_name': 'Pelin nimi',
        'most_popular_games': 'Pelatuimmat pelit',
        'latest_events': 'Viimeisimmät tapahtumat',
        'description_of_event': 'Tapahtuman kuvaus',
        'when': 'Milloin',
        'ago': 'sitten',
        'weeks': 'viikkoa',
        'days': 'päivää',
        'hours': 'tuntia',
        'months': 'kuukautta',
        'week': 'viikko',
        'day': 'päivä',
        'hour': 'tunti',
        'month': 'kuukausi',
        'theme_and_image': 'Teema ja nostokuva',
        'start_screen': 'Aloitusruutu',
        'end_screen': 'Lopetusruutu',
        'end_screen_text': 'Lopetusruudun teksti',
        'end_screen_points': 'Lopputuloksen pisterajat',
        'edit_team': 'Muokkaa tiimiä',
        'avg_max': 'Keskiarvo / maksimi',
        'allowed_domains': 'Sallitut sähköpostipäätteet',
        'url_copied': 'URL kopioitu leikepöydälle!',
        'url_copy_failed': 'URL:n kopioiminen epäonnistui.',
        'passed': 'Läpäisty',
        'connected': 'Yhdistettiin',
        'selections': 'Valintakerrat',
        'times': 'kertaa',
        'video': 'Video',
        'game_created': 'Peli luotu',
        'min_points': 'Pelin läpäisyyn vaadittavat pisteet %',
        'dashboard': 'Hallintapaneeli',
        'themes': 'Teemat',
        'start_screen_text': 'Aloitusruudun teksti',
        'terms': 'Tietosuojaseloste',
        'end_form_thanks': 'Kiitosviesti lopetusruudun lomakkeen jälkeen',
        'point_range_text': 'Pisterajan teksti',
        'required_points': 'Tarvittavat pisteet',
        'forms': 'Lomakkeet',
        'fields': 'Kentät',
        'new_form': 'Uusi lomake',
        'edit_form': 'Muokkaa lomaketta',
        'add_field': 'Lisää kenttä',
        'name_field': 'Nimikenttä',
        'email_field': 'Sähköpostikenttä',
        'custom_field': 'Mukautettu kenttä',
        'field_label': 'Kentän nimi',
        'field_type': 'Tyyppi',
        'field_required': 'Pakollinen',
        'text': 'Teksti',
        'checkbox': 'Valintalaatikko',
        'text_element': 'Tekstirivi',
        'used_in_games': 'Käytössä peleissä',
        'date_joined': 'Liittynyt',
        'last_seen': 'Viimeksi nähty',
        'invitation_link': 'Kutsulinkki',
        'start_date': 'Aloituspvm.',
        'end_date': 'Lopetuspvm.',
        'games_played_total': 'Kaikki pelatut pelit',
        'compared_to_previous': 'Verrattuna edelliseen jaksoon',
        'new': 'Uusi',
        'new_plural': 'Uudet',
        'total': 'Yhteensä',
        'days_abbreviation': 'pv',
        'right_answers': 'Täysin oikeita vastauksia',
        'wrong_answers': 'Täysin vääriä vastauksia',
        'question_type': 'Kysymystyyppi',
        'team': 'Tiimi',
        'search_teams': 'Hae tiimejä',
        'enter_emails': 'Lisää sähköpostipäätteitä',
        'enter_emails_help': 'Syötä sähköpostipäätteitä ja paina Enter',
        'correct_positions': 'Oikeat sijainti',
        'incorrect_positions': 'Väärät sijainnit',
        'summary': 'Yhteenveto',
        'positions': 'Sijainnit',
        'position': 'Sijainti',
        'no_data': 'Ei dataa saatavilla',
        'correct_pairs': 'Oikeat parit',
        'correct_connections': 'Oikein yhdistetty',
        'incorrect_connections': 'Väärin yhdistetty',
        'section_settings': 'Osion asetukset',
        'game_sections_and_contents': 'Pelin osiot ja sisällöt',
        'game_settings': 'Pelin asetukset',
        'slide_positioning': 'Sliden asemointi',
        'or': 'tai',
        'slide_content': 'Sliden sisältö',
        'delete': 'Poista',
        'confirm_delete_session': 'Haluatko varmasti poistaa pelisession?',
        'confirm_delete_theme': 'Haluatko varmasti poistaa teeman?',
        'no': 'Ei',
        'yes': 'Kyllä',
        'connected_to': 'Yhdistetty',
        'connections': 'Yhdistelmät',
        'select_teams': 'Valitse tiimit',
        'no_teams_selected': 'Ei valittuja tiimejä',
        'is_superuser': 'Pääkäyttäjä',
        'loading': 'Ladataan...',
        'inactive': 'Ei käytössä',
        'used_in': 'Käytössä',
        'logout': 'Kirjaudu ulos',
        'back_to_site': 'Takaisin sivustolle',
        'add': 'Lisää',
        'allowed_teams': 'Rajattu tiimeille',
        'restrict_playing': 'Rajoita pelaaminen vain kirjautuneille',
        'only_login': 'Vain kirjautuneille',
        'game_min_points': 'Läpäisyyn vaadittavat pisteet',
        'language_settings': 'Kielikohtaiset asetukset',
        'start_screen_form': 'Aloitusruudun lomake',
        'start_screen_form_help': 'Valitse lomake, joka näytetään pelin aloitusruudulla.',
        'end_screen_form': 'Lopetusruudun lomake',
        'select_form': 'Valitse lomake',
        'theme_and_lift_settings': 'Teema- ja nostoasetukset',
        'show_lift': 'Näytä nosto sivustolla',
        'show_lift_help': 'Nosto pelistä näytetään sivustolla, jos peli on käytössä.',
        'date_range': 'Aikarajaus',
        'confirm_delete_question': 'Haluatko varmasti poistaa kysymyksen?',
        'confirm_delete_section': 'Haluatko varmasti poistaa osion ja kaikki sen sisällöt?',
        'confirm_delete_user': 'Haluatko varmasti poistaa käyttäjän?',
        'section': 'Osio',
        'question': 'Kysymys',
        'lift_image_help': 'Näytetään pelin aloitusruudulla sekä nostoissa<br>sallitut kuvamuodot png/jpg koko 500x500px',
        'theme_help': 'Valitse tai lisää peliin sopiva teema <br> Teemaa käytetään myös pelin osioissa jos niissä ei ole omaa teemaa',
        'team_help': 'Rajaa peli tiimeille, jotka voivat pelata peliä',
        'display_correct_help': 'Näytä oikeat vastaukset sekä pisteet pelaajille',
        'restrict_playing_help': 'Rajoita pelaaminen vain kirjautuneille käyttäjille',
        'upload_image': 'Lataa kuva',
        
        'end_title': 'Lopetusruudun otsikko',
        'is_active_help_text': 'Onko peli pelattavissa kieliversiolla',
        'publish_version': 'Julkaise versio',
        'publish_in': 'Ota peli käyttöön kielellä',
        'screens': 'Aloitus- ja lopetusruudun asetukset',
        'game_end_redirect': 'Pelin lopetuksen ohjausosoite',
        'event_details': 'Tapahtuman tiedot',
        'changes': 'Muutokset',
        'field': 'Kenttä',
        'old_value': 'Vanha arvo',
        'new_value': 'Uusi arvo',
        'delete_language_version': 'Poista kieliversio',
        'confirm_delete_game_language': 'Haluatko varmasti poistaa pelin kieliversion? <br> Jos poistat kaikki kieliversiot, peli arkistoidaan kokonaan.',
        'game_language_version': 'Pelin kieliversio',
        'not_found_title': 'Sivua ei löytynyt',
        'not_found_description': 'Hups, sivua ei löytynyt!',
        'version_override_help': 'Olet julkaisemassa pelistä uutta versiota. Muutokset näkyvät pelissä heti.',
        'type_open_text': 'Tekstivastaus',
        'draft_info': 'Huom! Pelin nykyinen versio on julkaistu, kaikki muutokset näkyvät peleissä heti.',
        'theme_info': 'Huom! Teema on käytössä, kaikki muutokset näkyvät peleissä heti.',
        'confirm_delete_form': 'Haluatko varmasti poistaa lomakkeen?',
        'confirm_delete_team': 'Haluatko varmasti poistaa tiimin?',
        'user': 'Käyttäjä',
        'is_active_info': 'Huom! Jos peli on julkaistu, kaikki muutokset näkyvät heti pelissä.',
        'open_options': 'Tekstivastaus',
        'textarea': 'Tekstialue',
        'create': 'Luo',
        'confirm_draft_create': 'Huom! Luo uusi versio vain, jos haluat muokata kysymysten pisteitä tai vastausvaihtoehtoja tai lisätä sivuja tai osioita.',
        'export_to_excel': 'Vie Exceliin',
        'upload_video': 'Lataa video',
        'published_info': 'Huom! Julkaistussa versiossa et voi muokata pelin pisteitä tai lisätä sisältöjä.<br> Jos haluat tehdä muutoksia, luo uusi versio.',
        'no_options': 'Ei hakutuloksia',
        'theme_help_section': 'Valitse tai lisää osioon sopiva teema <br> Tämä yliajaa pelin teeman.',
        'confirm_delete': 'Vahvista poisto',
        'playable': 'Pelattavissa',
        'create_new_version': 'Luo uusi versio',
        'continue_editing': 'Jatka version muokkaamista',
        'end_screen_points_help': 'Voit luoda pisterajoihin perustuvia viestejä, jotka näytetään pelaajalle pelin päätyttyä.',
        'excerpt_help': 'Nostotekstiä käytetään sivuston nostoissa, jos nosto näytetään sivustolla.',
        'theme_image_help': 'Kuvaa käytetään taustakuvana<br> Kuvakoko 1920x1080 <br> Sallitut kuvamuodot png/jpg',
        'enter_emails_help_text': 'Tiimiin liittyminen sallitaan vain valituilla sähköpostipäätteillä, voit lisätä useita sähköpostipäätteitä.',
        'copy_team_url': 'Kopioi kutsu-URL leikepöydälle',
        'copy_url': 'Kopioi URL',
        'slide_image_help': 'Sallitut kuvamuodot png/jpg',
        'slide_video_help': 'Sallitut videotyypit mp4',
        'just_now': 'juuri nyt',
        'change': 'Vaihda',
        'state': 'Tila',
        'preview': 'Esikatselu',
        'admin': 'Hallinta',
        'autoplay': 'Automaattinen toisto',
        'loop_video': 'Toista video jatkuvasti',
        'only_title': 'Näytä vain otsikko taustan päällä',
        'invitation_links': 'Kutsulinkit',
        'edit_link': 'Muokkaa kutsulinkkiä',
        'new_link': 'Uusi kutsulinkki',
        'max_usages': 'Käyttömäärä',
        'use_end': 'Vanhenee',
        'use_amount': 'Käyttömäärä',
        'is_anonymous': 'Anonyymi',
        'select_team': 'Valitse tiimi',
        'select_game': 'Valitse peli',
        'created_by': 'Luonut',
        'description_emails': 'Sähköpostiosoitteet / Kuvaus',
        'ago_abbr': '',
        'background_image': 'Taustakuva',
        'logo': 'Logo',
        'theme_logo_help': 'Kuvaa käytetään teeman logona<br> Käytä vain vaakakuvia <br> Sallitut kuvamuodot png/jpg/svg',
        'save_and_continue': 'Tallenna ja jatka muokkaamista',
        'shuffle_options': 'Näytä vastausvaihtoehdot arvotussa järjestyksessä',
        'select_basic': 'Vaihtoehto',
        'select_open': 'Avoin vastaus',
        'display_end_screen_points': 'Näytä pisteet lopetusruudulla',
        'display_end_screen_points_help': 'Näytä pelaajalle pelin pisteet lopetusruudulla',
        'change_remove': 'Vaihda / Poista',
        'image_help': 'Sallitut kuvamuodot png/jpg',
        
        'section_background_help': 'Kuvaa käytetään osion taustakuvana<br> Kuvakoko 1920x1080 <br> Sallitut kuvamuodot png/jpg',
        'layout': 'Asettelu',
        'default': 'Oletus',
        'tag_layout': 'Tagit',
        'twin_columns': 'Kaksipalstainen',
        'add_content': 'Lisää sisältöä',
        'element': 'Elementti',
        'settings': 'Asetukset',
        'confirm_delete_element': 'Haluatko varmasti poistaa elementin?',
        'confirm_delete_row': 'Haluatko varmasti poistaa rivin ja kaikki sen sisältämät sisällöt?',
        'edit_element': 'Muokkaa elementtiä',
        'add_element': 'Lisää elementti',
        'notifications': 'Ilmoitukset',
        'upload_pdf': 'Tuo sisältö (PDF)',
        'pdf_file': 'PDF-tiedosto',
        'pdf_file_help': 'PDF-tiedoston sivuista luodaan osion sisällöt.',
        'description_info': 'Lisäkuvaus, joka näytetään kysymyksen yhteydessä.',
        'element_image_title_help': 'Tämä teksti näkyy vain hallinnassa.',
        'pdf_processing_pending': 'Odotetaan PDF-tiedoston käsittelyä',
        'pdf_processing_in_progress': 'Käsitellään PDF-tiedostoa',
        'pdf_processing_completed': 'PDF-tiedoston käsittely valmis',
        'pdf_processing_failed': 'PDF-tiedoston käsittely epäonnistui',
        'pdf_page': 'sivu',
        'statistics': 'Tilastot',
        'export_pdf': 'Lataa PDF',
        'time_limit': 'Aikaraja (s)',
        'time_limit_help': 'Sallittu aika vastata kysymykseen sekunteina 5-3600 s',
        'number_scale': 'Numeroasteikko',
        'min_value': 'Minimi',
        'max_value': 'Maksimi',
        'nps_scale': 'NPS-asteikko',
        'nps_low': 'Erittäin epätodennäköisesti',
        'nps_high': 'Erittäin todennäköisesti',
        'rating': 'Arvosana',
        'label': 'Teksti',
        'percentage': 'Prosenttia',
        'nps_rating': 'NPS-indeksi',
        'promoters': 'Suosittelijat (9-10)',
        'passives': 'Passiiviset (7-8)',
        'detractors': 'Kriittiset (0-6)',
        'allow_answer_change': 'Salli vastauksen vaihto',
        'allow_answer_change_help': 'Salli pelaajalle mahdollisuus vaihtaa vastaustaan',
        'allow_skip': 'Salli kysymyksen ohitus',
        'skip_question': 'Jätä vastaamatta',
        'og_image': 'OG-kuva',
        'og_image_help': 'Sallitut kuvamuodot png/jpg, suositeltu kuvakoko 1200x630 px.',
    },
    'en': {
        'export': 'Export',
        'text_element': 'Text',
        'sections': 'Sections',
        'start': 'Start',
        'answer': 'Answer',
        'play_again': 'Play again',
        'remove_selection': 'Remove selection',
        'continue': 'Continue',
        'choose_answer': 'Choose answer',
        'close': 'Close',
        'fill_all_fields': 'Fill all fields',
        'select_multiple_info': 'Select one or more options',
        'select_single_info': 'Select one option',
        'order_info': 'Order the options correctly',
        'connect_info': 'Connect the correct options',
        'error_loading_game': 'Error loading game',
        'points_scored': 'Points',
        'game_average': 'Game average',
        'all_players_average': 'All players average',
        'confirm_exit': 'Are you sure you want to exit? The game cannot be shared if you exit during the game.',
        'page': 'Page',
        'pages': 'Pages',
        'filter': 'Filter',
        'search_games': 'Search games',
        'add_game': 'Add game',
        'game_language': 'Game language',
        'game_languages': 'Game languages',
        'all_languages': 'All languages',
        'game_status': 'Game status',
        'status': 'Status',
        'status_published': 'Published',
        'status_draft': 'Draft',
        'status_archived': 'Archived',
        'status_not_in_use': 'Not in use',
        'own_modified': 'Own modified',
        'name': 'Name',
        'games_played': 'Games played',
        'modified': 'Modified',
        'actions': 'Actions',
        'all': 'All',
        'clear_filters': 'Clear filters',
        'back_to_list': 'Back to list',
        'edit': 'Edit',
        'common_info': 'Common Info',
        'average_duration': 'Average duration',
        'average': 'Average',
        'min': 'min',
        'sec': 'sec',
        'average_points': 'Average points',
        'max_points': 'Max points',
        'game_image': 'Game image',
        'terms': 'Privacy policy',
        'end_form_thanks': 'Thank you message (after form)',
        'general': 'General',
        'slug': 'Slug',
        'description': 'Description',
        'excerpt': 'Excerpt',
        'outro_text': 'Outro text',
        'multiple': 'Multiple',
        'content_type': 'Content type',
        'title': 'Title',
        'select_options': 'Options',
        'add_option': 'Add option',
        'points': 'Points',
        'order_options': 'Order options',
        'connect_options': 'Connect options',
        'save': 'Save',
        'select_question_type': 'Select question type',
        'all_types': 'All types',
        'type_slide': 'Slide',
        'type_select': 'Select',
        'type_order': 'Order',
        'type_connect': 'Connect',
        'type_image': 'Image',
        'new_question': 'New question',
        'new_content': 'New content',
        'new_game': 'New game',
        'theme': 'Theme',
        'search': 'Search...',
        'select': 'Select',
        'new_section': 'New section',
        'quit_game': 'Quit game',
        'submit': 'Submit',
        'cancel': 'Cancel',
        'add_new': 'Add new',
        'section_updated': 'Section updated',
        'section_created': 'Section created',
        'not_available': 'Not available',
        'game_section_order_updated': 'Game section order updated',
        'game_saved': 'Game details saved',
        'question_created': 'Question created',
        'question_updated': 'Question updated',
        'add_language': 'Add language',
        'select_language': 'Select language',
        'edit_order': 'Edit order',
        'language_versions': 'Language versions',
        'latest_sessions': 'Latest sessions',
        'session': 'Game session',
        'sessions': 'Game sessions',
        'started': 'Started',
        'ended': 'Ended',
        'question_language': 'Question language',
        'search_questions': 'Search questions',
        'show_all': 'Show all',
        'played': 'Played',
        'created': 'Created',
        'language': 'Language',
        'languages': 'Languages',
        'type': 'Type',
        'duration': 'Duration',
        'select_status': 'Select status',
        'search_sessions': 'Search sessions',
        'games': 'Games',
        'questions': 'Questions',
        'questions_played': 'Questions played',
        'users': 'Users',
        'player_name': 'Player name',
        'duplicate': 'Duplicate as new',
        'game_duplicated': 'Game duplicated',
        'new_theme': 'New theme',
        'add_theme': 'Add theme',
        'image': 'Image',
        'add_user': 'Add user',
        'search_users': 'Search users',
        'add_team': 'Add team',
        'teams': 'Teams',
        'email': 'Email',
        'is_staff': 'Is staff',
        'is_active': 'Is active',
        'new_user': 'New user',
        'edit_user': 'Edit user',
        'first_name': 'First name',
        'last_name': 'Last name',
        'password': 'Password',
        'repeat_password': 'Repeat password',
        'new_team': 'New team',
        'team_name': 'Team name',
        'allowed_emails': 'Allowed emails',
        'section_contents': 'Section contents',
        'display_correct_answers': 'Display correct answers',
        'select_theme': 'Select theme',
        'question_and_answer': 'Question and answer',
        'answered': 'Answered',
        'slides': 'Slides',
        'in_game': 'in game',
        'order': 'Order',
        'average_order': 'Average order',
        'game_name': 'Game name',
        'most_popular_games': 'Most popular games',
        'og_image': 'OG image',
        'og_image_help': 'Allowed image formats png/jpg, recommended size 1200x630 px.',
    }
};
